export default {
	computed: {
		isRegularUser() {
			return this.$store.getters['userStore/isRegularUser'];
		},
	},
	created() {
		if (!this.isRegularUser) {
			const options = {
				okLabel: '확인',
				message: this.noAccessMessage || '정회원 전용 메뉴입니다.',
			};
			this.showAlert(options).then(() => {
				this.$router.go(-1);
			});
		}
	},
};
